//@ts-nocheck

import React from "react";

import * as S from "./ModalAuth.styles";

import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import { SpacerBase } from "../../../atoms/GridSystem";
import Icon from "../../../atoms/Icon/Icon.component";
import Button from "../../../atoms/Button/Button.component";

import { useModal } from "../../../../contexts/Modal.context";

const ModalAuth = ({
  title,
  description,
  cta,
  callback = () => {}
}: {
  title: string;
  description: string;
  cta: {
    label: string;
    handleClick: () => void;
  };
  callback: () => void;
}) => {
  const { closeModal } = useModal();

  return (
    <S.ModalAuth>
      <S.ModalAuthIconWrapper
        onClick={() => {
          closeModal();
          callback();
        }}
      >
        <Icon name="x-mark" />
      </S.ModalAuthIconWrapper>
      <S.ModalAuthContent>
        <Heading content={title} typo="headingMD" />
        <SpacerBase xs={2} />
        <Paragraph content={description} typo="paragraphMD" />
        { cta && cta.label ? (
          <>
            <SpacerBase xs={4} />
            <Button
              label={cta.label}
              handleClick={() => {
                closeModal();
                cta?.handleClick();
              }}
              fullWidth
            />
          </>
        ) : null}
      </S.ModalAuthContent>
    </S.ModalAuth>
  )
}

export default ModalAuth